import { Badge } from "../../ui/badge"
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from "../../ui/select"
import { Calendar, User, CheckCircle } from "lucide-react"
import { format } from "date-fns"

export const VersionCardHeader = ({ versionNumber, status, submittedBy, createdAt, handleStatusChange, approvedBy, approvedByClient, approvedOn }) => {
  const getStatusColor = status => {
    switch (status) {
      case "Approved":
        return "bg-green-100 text-green-800"
      case "Re-edit":
        return "bg-red-100 text-red-800"
      case "Pending":
        return "bg-yellow-100 text-yellow-800"
      default:
        return "bg-gray-100 text-gray-800"
    }
  }

  const getApprovalText = () => {
    const roleText = approvedByClient ? "Client" : "Internal User";
    const approverName = approvedBy && approvedBy.name ? approvedBy.name : "Unknown";
    return `Approved by ${roleText} (${approverName})`;
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Version {versionNumber}</h3>
        <div className="flex items-center gap-3">
          <Badge className={getStatusColor(status)}>{status}</Badge>
          {!approvedByClient && (
            <Select
              value={status}
              onValueChange={value => handleStatusChange(versionNumber, value)}
            >
              <SelectTrigger className="w-32">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Pending">Pending</SelectItem>
                <SelectItem value="Re-edit">Re-edit</SelectItem>
                <SelectItem value="Approved">Approved</SelectItem>
              </SelectContent>
            </Select>
          )}
        </div>
      </div>

      <div className="flex items-center gap-6 text-sm text-gray-500 flex-wrap">
        <span className="flex items-center gap-1">
          <User className="w-4 h-4" />
          Submitted by: <span className="font-medium">{submittedBy && submittedBy.name ? submittedBy.name : "Unknown"}</span>
        </span>
        <span className="flex items-center gap-1">
          <Calendar className="w-4 h-4" />
          {createdAt ? format(new Date(createdAt), "dd MMM, yyyy") : "N/A"}
        </span>
      </div>

      {/* Approval Information */}
      {status === "Approved" && approvedBy && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-3 mt-3">
          <div className="flex items-center gap-2 text-green-800">
            <CheckCircle className="w-4 h-4" />
            <span className="font-medium">{getApprovalText()}</span>
          </div>
          <div className="text-green-700 text-sm mt-1">
            Approved on{" "}
            {approvedOn ? format(new Date(approvedOn), "dd MMM, yyyy 'at' HH:mm") : "N/A"}
          </div>
        </div>
      )}
    </>
  )
}
